import {
    GET_TRANSACTION_DETAILS_START,
    GET_TRANSACTION_DETAILS_SUCCESS,
    GET_TRANSACTION_DETAILS_ERROR,
} from "../Constant/TourTransactionDetailConstant";

const initialState = {
    loading: false,
    transactionDetaildata: [],
};
export default function TourTransactionDetailsReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case GET_TRANSACTION_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case GET_TRANSACTION_DETAILS_SUCCESS:
            return {
                ...state,
                transactionDetaildata: action.payload,
                loading: false,
            };


        case GET_TRANSACTION_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

